import axios from 'axios'
import Papa from 'papaparse'
import Rainbow from 'rainbowvis.js'

export function readingsToCsv(readings) {
  const csv = Papa.unparse(readings)
  return csv
}

export function downloadTextFile(filename, text) {
  const element = document.createElement('a')
  const file = new Blob([text], { type: 'text/plain' })
  element.href = URL.createObjectURL(file)
  element.download = filename
  document.body.appendChild(element) // Required for this to work in FireFox
  element.click()
}

// const formatterPT1 = new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 1, maximumFractionDigits: 1})
// const formatterPT0 = new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 1, maximumFractionDigits: 0})
// const formatterPT3 = new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 1, maximumFractionDigits: 3})

export function formatNumber(number, decimals = 1, locale = 'fr-FR') {
  decimals = decimals === undefined ? 1 : decimals
  return new Intl.NumberFormat(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(
    number
  )
}

export function getOperatorLogoSrc(operatorName) {
  return `/operadores/${operatorName.toLowerCase()}.png`
}

export function getOperatorColors(operatorName) {}

export function capitalize(s) {
  return s && s[0].toUpperCase() + s.slice(1)
}

export function getColorRamp(startColor, endColor, numberOfColors) {
  if (numberOfColors < 2) return [startColor]

  var rainbow = new Rainbow()

  rainbow.setNumberRange(1, numberOfColors)

  rainbow.setSpectrum(startColor, endColor)

  let colors = []

  for (var i = 1; i <= numberOfColors; i++) {
    colors.push(`#${rainbow.colourAt(i)}`)
  }
  return colors
}
